var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinkGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 29.9982C14.0625 27.0255 14.8815 24.2408 16.3044 21.8564V11.7422H6.19019C2.17594 16.9556 0 23.3094 0 29.9982C0 36.6871 2.17594 43.0408 6.19019 48.2543H16.3044V38.1401C14.8815 35.7556 14.0625 32.9709 14.0625 29.9982V29.9982Z",
    fill: "#F26283"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 45.9362L22.9688 52.9675L30 59.9987C36.6889 59.9987 43.0426 57.8228 48.256 53.8085V43.7051H38.1526C35.7473 45.1331 32.9509 45.9362 30 45.9362V45.9362Z",
    fill: "#F26283"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3037 38.1426L6.18945 48.2568C6.98422 49.289 7.84965 50.2775 8.78609 51.214C14.4523 56.8801 21.986 60.0007 29.9992 60.0007V45.9382C24.1839 45.9382 19.0871 42.807 16.3037 38.1426Z",
    fill: "#F26283"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 30.0011C60 28.1759 59.8347 26.3473 59.5087 24.5663L59.2449 23.125H30V37.1875H44.2326C42.8505 39.9368 40.7255 42.1799 38.1525 43.7076L48.2559 53.811C49.2881 53.0162 50.2766 52.1508 51.2131 51.2144C56.8794 45.548 60 38.0144 60 30.0011V30.0011Z",
    fill: "#F26283"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2696 18.7304L42.5124 19.9733L52.4562 10.0297L51.2133 8.78683C45.547 3.12058 38.0134 0 30 0L22.9688 7.03124L30 14.0625C34.2569 14.0625 38.2592 15.7202 41.2696 18.7304Z",
    fill: "#F26283"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9994 14.0625V0C21.9861 0 14.4525 3.12058 8.78609 8.78671C7.84965 9.72316 6.98422 10.7116 6.18945 11.7439L16.3037 21.8581C19.0872 17.1937 24.184 14.0625 29.9994 14.0625V14.0625Z",
    fill: "#F26283"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkGoogleIcon);
export default __webpack_public_path__ + "static/media/pinkGoogleIcon.cb86b7edc6220f72fa4cf8e71e3560ab.svg";
export { ForwardRef as ReactComponent };